/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, TextField, Button } from '@components/atoms'
import { FullModalLayout, ResetPasswordTextField } from '@components/molecules'
import { mono, boShared } from '@components/systems/backoffice/backoffice.tokens'

import {
	useAppDispatch,
	useAppSelector,
	routeActions,
	adminUsersActions,
} from '@redux/index'
import { Validator, ValidatorResultType } from '@validators'
import { UserType } from '@schemas'

/** 관리자 → 사용자 패스워드 변경. 한 컬럼, 밑줄 입력(MUI standard 는 테마가 밑줄로 그린다), 블랙 CTA 하나 */
const ResetPasswordPage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const userInfo: UserType = useAppSelector(state => state.adminUsers.editPasswordUser)
	const resetPasswordErrorMessage: string = useAppSelector(
		state => state.adminUsers.resetPasswordErrorMessage,
	)

	// state
	const [name, setName] = React.useState<string>(userInfo.name)
	const [password, setPassword] = React.useState<string>('')

	React.useEffect(() => {
		if (['', undefined, null].includes(userInfo.id)) {
			onCloseClick()
		}
	}, [userInfo])

	const onCloseClick = React.useCallback(() => {
		reduxDispatch(routeActions.NAVIGATE_PATH('/admin/users'))
	}, [])

	const onResetPasswordChange = (str: string) => {
		setPassword(str)
	}

	const onNameChange = (e: any) => {
		const newName: string = e.target.value
		setName(newName)
	}

	const onResetPasswordSubmitClick = () => {
		const res: ValidatorResultType = Validator.users({
			password: password,
		})

		if (res['password'].isValid) {
			reduxDispatch(
				adminUsersActions.UPDATE_RESET_PASSWORD({
					id: userInfo.id,
					name: name,
					password: password,
				}),
			)
		} else {
			reduxDispatch(
				adminUsersActions.RESET_PASSWORD_ERROR_MESSAGE(res['password'].message),
			)
		}
	}

	return (
		<View css={style}>
			<FullModalLayout title="패스워드 변경" onCloseClick={onCloseClick} size="small">
				<View className="resetPasswordOuterView">
					<View className="textFieldView">
						<TextField
							label="ID (수정 불가)"
							variant="standard"
							defaultValue={userInfo.id}
							InputProps={{
								readOnly: true,
							}}
						/>
					</View>

					<View className="textFieldView">
						<TextField
							label="이름"
							variant="standard"
							defaultValue={userInfo.name}
							onChange={onNameChange}
						/>
					</View>

					<View className="textFieldView">
						<ResetPasswordTextField
							label="패스워드"
							onChange={onResetPasswordChange}
							isResetPassword={true}
							variant="standard"
							errorMessage={resetPasswordErrorMessage}
						/>
					</View>

					<View className="bottomView">
						<Button variant="contained" onClick={onResetPasswordSubmitClick}>
							패스워드 저장
						</Button>
					</View>
				</View>
			</FullModalLayout>
		</View>
	)
}

export default ResetPasswordPage

const style = css({
	...boShared,

	'.resetPasswordOuterView': {
		position: 'relative',
		overflow: 'auto',
		textAlign: 'left',
		borderTop: `1px solid ${mono.line}`,
		paddingTop: 8,

		'.textFieldView': {
			marginTop: 20,
		},

		'.bottomView': {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			width: '100%',
			marginTop: 40,
			paddingTop: 20,
			borderTop: `1px solid ${mono.line}`,
		},
	},
})
